import { render, staticRenderFns } from "./OffersAnimationSection.vue?vue&type=template&id=c0d52f24&scoped=true&"
import script from "./OffersAnimationSection.vue?vue&type=script&lang=ts&"
export * from "./OffersAnimationSection.vue?vue&type=script&lang=ts&"
import style0 from "./OffersAnimationSection.vue?vue&type=style&index=0&id=c0d52f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d52f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0d52f24')) {
      api.createRecord('c0d52f24', component.options)
    } else {
      api.reload('c0d52f24', component.options)
    }
    module.hot.accept("./OffersAnimationSection.vue?vue&type=template&id=c0d52f24&scoped=true&", function () {
      api.rerender('c0d52f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/animation/OffersAnimationSection.vue"
export default component.exports